var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 104,
    viewBox: "0 0 100 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.65 87.2754C52.6955 92.7049 48.3435 97.1472 42.9125 97.1887C37.4847 97.238 33.0474 92.8818 33.0019 87.4523C32.9888 86.0067 33.3116 84.631 33.8668 83.3871L51.7088 83.2262C52.2898 84.4598 52.6374 85.8272 52.6496 87.2751L52.65 87.2754Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.487 42.9072C16.8124 30.424 23.3218 21.1811 32.5034 17.2414C32.4201 16.7311 32.3108 16.2453 32.3061 15.7013C32.2596 10.2741 36.6094 5.84447 42.0416 5.80012C47.4672 5.74987 51.9043 10.1125 51.9494 15.5353C51.9601 16.0501 51.8716 16.5412 51.7967 17.0382C61.369 20.9051 68.2655 30.7017 68.9559 42.633C68.9559 42.633 69.0773 62.3958 76.4805 67.1333C76.7187 67.2514 80.9432 69.1882 80.9103 72.8623C80.8757 76.337 76.6613 79.1921 71.4511 79.2033L14.9844 79.3384C9.77489 79.3497 5.24535 76.5126 5.49429 73.0469C5.73878 69.6369 9.17467 67.8365 9.49538 67.6786C16.9498 62.6945 16.4862 42.9079 16.4862 42.9079L16.487 42.9072Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell_Icon.62b746e39dcb0cbccd3f757d69d1c60c.svg";
export { ForwardRef as ReactComponent };